module.exports = __webpack_public_path__ + "img/08.8d31a612.png";